import { render, staticRenderFns } from "./SelectWidgetType.vue?vue&type=template&id=f0ba73a2&scoped=true"
import script from "./SelectWidgetType.vue?vue&type=script&lang=js"
export * from "./SelectWidgetType.vue?vue&type=script&lang=js"
import style0 from "./SelectWidgetType.vue?vue&type=style&index=0&id=f0ba73a2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0ba73a2",
  null
  
)

export default component.exports